export function EmptyState({ label }: { label: string }) {
  return (
    <div className="rounded-xl border border-dashed border-border/80 bg-background/40 px-4 py-6 text-sm text-muted-foreground">
      {label}
    </div>
  );
}
